import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { Building2, Users, Briefcase, FileText, Mail } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 dark:bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/render/image/public/base44-prod/public/696ac43216f2dcd8c8bf25f9/af21d9783_Clinivologo.PNG?width=96&height=96&resize=contain&quality=80" 
              alt="Clinivo - Healthcare Careers, Elevated"
              width={48}
              height={48}
              className="h-12 mb-4 object-contain"
            />
            <p className="text-sm text-slate-400">
              Connecting healthcare professionals with top employers nationwide. Elevate your career with Clinivo.
            </p>
          </div>

          {/* For Job Seekers */}
          <div>
            <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
              <Users className="h-4 w-4" />
              For Job Seekers
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={createPageUrl('NursingJobs')} className="hover:text-teal-400 transition-colors font-medium text-teal-400">
                  RN Jobs
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('NursingJobs?type=lpn')} className="hover:text-teal-400 transition-colors font-medium text-teal-400">
                  LPN / LVN Jobs
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('JobsByLocation?path=travel-nursing-jobs')} className="hover:text-teal-400 transition-colors">
                  Travel Nursing Jobs
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('JobSpecialties')} className="hover:text-teal-400 transition-colors">
                  Browse by Specialty
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('SalaryCalculator')} className="hover:text-teal-400 transition-colors">
                  Salary Calculator
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-teal-400 transition-colors">
                  Browse All Jobs
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('ContactSupport')} className="hover:text-teal-400 transition-colors">
                  Get Support
                </Link>
              </li>
            </ul>
          </div>

          {/* For Employers */}
          <div>
            <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              For Employers
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={createPageUrl('ForEmployers')} className="hover:text-teal-400 transition-colors">
                  For Employers
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('PostJob')} className="hover:text-teal-400 transition-colors">
                  Post a Job
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('Subscription')} className="hover:text-teal-400 transition-colors">
                  Pricing Plans
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('ROICalculator')} className="hover:text-teal-400 transition-colors">
                  ROI Calculator
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('SuccessStories')} className="hover:text-teal-400 transition-colors">
                  Success Stories
                </Link>
              </li>

            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Resources
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to={createPageUrl('Blog')} className="hover:text-teal-400 transition-colors">
                  Career Blog
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('Forum')} className="hover:text-teal-400 transition-colors">
                  Community Forum
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('Newsletter')} className="hover:text-teal-400 transition-colors">
                  Weekly Newsletter
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('ResumeBuilder')} className="hover:text-teal-400 transition-colors">
                  Resume Builder
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('IndustryGuides')} className="hover:text-teal-400 transition-colors">
                  Industry Guides
                </Link>
              </li>
              <li>
                <Link to={createPageUrl('HealthcareStats')} className="hover:text-teal-400 transition-colors">
                  Healthcare Statistics
                </Link>
              </li>
              <li>
                <a href="/sitemap.xml" className="hover:text-teal-400 transition-colors" target="_blank" rel="noopener">
                  Sitemap
                </a>
              </li>
              <li>
                <Link to={createPageUrl('ContactSupport')} className="hover:text-teal-400 transition-colors flex items-center gap-1">
                  <Mail className="h-3 w-3" />
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-400">
          <p>© {currentYear} Clinivo. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to={createPageUrl('PrivacyPolicy')} className="hover:text-teal-400 transition-colors">Privacy Policy</Link>
            <Link to={createPageUrl('Terms')} className="hover:text-teal-400 transition-colors">Terms of Service</Link>
            <Link to={createPageUrl('ContactSupport')} className="hover:text-teal-400 transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}